import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {settings} from './settings'
import * as tokenObserver from './token-observer'
import {ISession, IUsersServices} from './types'
import jwtDecode from 'jwt-decode'

Vue.use(Vuex)

const controller = '/Account';

const initialState = {
  UserId: null,
  fullName: null,
  origin: null,
  roles: null,
  nbf: null,
  exp: null,
  iat: null,
  username: null,
  email: null,
  token: null,
  service: null,
  services: null,
  serviceId: null,
};

class Session {

  session: ISession = {} as ISession;

  private static storageKey: string = 'MEDIA_STATS_STORAGE';
 
  private static singleSession: Session;

  private constructor(init?: Partial<ISession>) {

    Object.assign(this.session, init);
  }

  public Save() {

    Session.SaveToken({
      token: this.session.token as string,
      service: this.session.service as string,
      serviceId: this.session.serviceId as number
    });
  }

  public Destroy() {

    Session.DestroySession();
  }

  public static LoadSession() {

    if (Session.singleSession) {

      return Session.singleSession;
    }

    const storage = sessionStorage.getItem(Session.storageKey);

    if (storage) {

      const cache = JSON.parse(storage) as {token: string, service: string, serviceId: number},
            strArray = cache.token.split('.'),
            session = jwtDecode(cache.token) as ISession
      
      session.token = cache.token;
      session.service = cache.service;
      session.serviceId = cache.serviceId;

      tokenObserver.getInstance(cache.token);

      Session.singleSession = new Session(session);

      return Session.singleSession;
    }
    
    return Session.singleSession = new Session(initialState);
  }

  public static SaveToken(storage: {token: string, service: string, serviceId: number} ): void {
    
    const cachedToken = sessionStorage.getItem(Session.storageKey);
    
    if (cachedToken && (JSON.parse(cachedToken).token != storage.token)) {

      tokenObserver.getInstance(storage.token);
    }
    
    sessionStorage.setItem(Session.storageKey, JSON.stringify(storage));
  }

  public static DestroySession(): void {

    tokenObserver.stopObserver();
    sessionStorage.removeItem(Session.storageKey);
  }
}

export default new Vuex.Store({

  state: Session.LoadSession(),

  getters: {

    Authenticated: state => state.session.UserId ? true : false,

    Moderator: state => state.session.roles != undefined ? true : false,

    Token: state => state.session.token,

    Service: state => state.session.service
  },

  actions: {

    async reauthenticate ({commit}) {

      try {

        const response = await axios.get(`${settings.apiUrl + controller}/RefreshToken`);

        commit('createSession', response.data);
      } catch (err) {

        console.error(err);
      }
    }
  },

  mutations: {

    createSession (state, payload: string) {
      
      const sessionOb = jwtDecode(payload) as ISession;

            sessionOb.token = payload;
            sessionOb.service = state.session.service;
            sessionOb.services = state.session.services;
            sessionOb.serviceId = state.session.serviceId;

      state.session = sessionOb;

      state.Save();
    },

    saveUserId (state, userId: string) {

      state.session.service = userId;

      state.Save();
    },

    saveServiceId (state, serviceId: number) {

      state.session.serviceId = serviceId;

      state.Save();
    },

    saveServices (state, services: IUsersServices[]) {

      Vue.set(state.session, 'services', services);
    },

    destroySession (state) {

      state.session = initialState;

      state.Destroy();
    },
  }
})